module.exports = __webpack_public_path__ + "static/elsa_0-f01cf6e4f19253515919e1077394308c.png";